<footer class="g-padx py-5 py-lg-5">
    <div class="brand-logo">
        <img src="./assets/img/project/stays-connect-logo.svg" alt="facebook" class="" />
    </div>
    <div class="footer-links">
        <ul>
            <li><a [routerLink]="['/home']" [fragment]="'about-us'">About Us</a></li>
            <li><a href="assets/terms_and_conditions_StaysConnect.pdf" target="_blank">Terms & Conditions</a></li>
            <!-- <li><a href="">Privacy Policy</a></li> -->
            <li><a [routerLink]="['/home']" [fragment]="'contact'">Contact Us</a></li>
            <!-- <li><a href="">Refer a customer</a></li>
            <li><a href="">Blog</a></li>
            <li><a href="">Careers</a></li> -->
        </ul>
    </div>
    <div class="copyright mt-4 pt-2  d-flex justify-content-center-lg">
        Copyright © {{currentYear}} Stays Connect. All rights reserved

        <div class="ms-auto d-flex">
            Version 2.3
        </div>
    </div>
</footer>